import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const config = {
  apiKey: "AIzaSyAMcfkbxYS6rSgvfy46ZCdW9CGENqbOoCo",
  authDomain: "psf-ffl.firebaseapp.com",
  databaseURL: "https://psf-ffl.firebaseio.com",
  projectId: "psf-ffl",
  storageBucket: "psf-ffl.appspot.com",
  messagingSenderId: "591749579837",
  timestampsInSnapshots: true
};

const app = initializeApp(config);
export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const storage = getStorage(app);
